import Workcell from './Workcell'

export default Workcell
